import { LOGIN_FORM_STEPS } from "../../login-form-new/common/contant";
import { LoginFormAuthResult } from "../../login-form-new/hooks/loginFormAuth.types";

import { CompanyServiceType } from "@vahak/core/dist/constants";

export enum COMPACT_AUTH_STEPS {
    PHONE = "phone",
    OTP = "otp"
}

export interface CompactLoginShellFooterState {
    ctaLabel: string;
    ctaDisabled: boolean;
    onCtaClick: () => void;
}

export interface CompactAuthConfig {
    onComplete: (status: LoginFormAuthResult) => void | Promise<void>;
    onStepChange?: (step: COMPACT_AUTH_STEPS) => void;
    sourceScreen?: string;
    isInitiatedFrom?: string;
    defaultPlaceId?: string;
    defaultCompanyName?: string;
    registrationServiceType?: CompanyServiceType;
}

export function compactAuthStepToLoginFormStep(step: COMPACT_AUTH_STEPS): LOGIN_FORM_STEPS {
    switch (step) {
        case COMPACT_AUTH_STEPS.PHONE:
            return LOGIN_FORM_STEPS.PHONE_NUMBER;
        case COMPACT_AUTH_STEPS.OTP:
            return LOGIN_FORM_STEPS.OTP;
        default:
            return LOGIN_FORM_STEPS.PHONE_NUMBER;
    }
}
